import { EDITING_NOTE } from './../constants/index';
import { NoteState } from './../types/noteTypes';
import { GET_NOTES, EDIT_NOTE, DELETE_NOTE, ADD_NOTE } from '../constants/index';
import { AnyAction } from 'redux';
import { NoteInterface } from '../../components/Notes';

const initialState: NoteState = {
  notes: [] as NoteInterface[]
}

const noteReducer = (state = initialState, action: AnyAction) => {
  const payload = action.payload;

  switch(action.type){

    case GET_NOTES:
      return {
        ...state,
        notes: payload
      }

    case ADD_NOTE:
      return {
        ...state,
        notes: state.notes.concat(payload)
      }
    
    case EDIT_NOTE:
      return {
        ...state,
        notes: state.notes.map((note: NoteInterface) => {
          if(note.id === payload.id) {
            return {
              ...note,
              text: payload.text,
              json: payload.json,
              updatedAt: payload.updatedAt,
              edit: payload.edit
            }
          } else {
            return note
          }
        })
      }

    case DELETE_NOTE:
      return {
        ...state,
        notes: state.notes.filter((note: NoteInterface) => note.id !== payload)
      }

    case EDITING_NOTE:
      return {
        ...state,
        notes: state.notes.map((note: NoteInterface) => {
          if(note.id === payload.walkId) {
            return {
              ...note,
              edit: payload.edit
            }
          } else {
            return note
          }
        })
      }
        
    default: 
      return state
  }
}

export default noteReducer;
